import { DocumentAssemblerCategoryPicker } from '../../../document-assembler';

interface AgentDocumentCategoryFieldProps {
  documentTemplateCategoryKey: string | undefined;
  onChange: (documentTemplateCategoryKey: string | undefined) => void;
  enabled: boolean;
}

export const AgentDocumentCategoryField = ({
  documentTemplateCategoryKey,
  onChange,
  enabled,
}: AgentDocumentCategoryFieldProps) => (
  <DocumentAssemblerCategoryPicker
    selectedCategoryKey={documentTemplateCategoryKey ?? ''}
    onSelect={(category) => onChange(category?.key ?? undefined)}
    label="Documents this step may produce"
    shouldFetchCategories={enabled}
    hint="Most agent steps have nothing to do with documents — leave this empty. Set it and the agent is shown only the templates in that category at run time, so a category holding none leaves it nothing to work from — the count beside each name is what it would see. Setting this never makes the step produce a document."
  />
);
